import sha256 from "crypto-js/sha256";
import dayjs from "dayjs";


export const buildCreateOnlineMerchantEntityPayload = (data) => {
  const staticPayload = {
    ...data,
    //append static values
    status: "ACTIVE",
    processor: "NUVEI",

    fpsEnable: false,
    amexEnable: false,
  }
  const pData = applyPreprocessors(staticPayload, structuredClone(staticPayload), ["base64EncodedTermsPdf", "preference", "tokenPoolMid", "currencyTxnLimitList"]);

  const payload = {
    status: pData.status,

    displayName: pData.displayName,
    name: pData.name,
    countryOrRegion: pData.countryOrRegion,
    legalName: pData.legalName,
    businessRegistration: pData.businessRegistration,
    businessEstablishedDate: dayjs(pData.businessEstablishedDate).toISOString(),
    address: pData.address,
    addressSecondaryLang: pData.addressSecondaryLang,
    city: pData.city,
    stateOrProvince: pData.stateOrProvince,
    contactPerson: pData.contactPerson,
    email: pData.email,
    phone: pData.phone,
    mcc: pData.mcc,
    ...pData.base64EncodedImg && { base64EncodedImg: pData.base64EncodedImg },
    homepage_url: pData.homepage_url,
    theme_color: pData.theme_color,
    count_down: pData.count_down,
    callback_countdown: pData.callback_countdown,
    ...pData.base64EncodedTermsPdf && { base64EncodedTermsPdf: pData.base64EncodedTermsPdf },
    ...(pData.termsUrl != null) && { termsUrl: pData.termsUrl }, //handle empty string case
    isBoxsPayMerchant: pData.isBoxsPayMerchant,

    currencyList: pData.currencyList,
    shareholderInfo: pData.shareholderInfo,
    currencyTxnLimitList: pData.currencyTxnLimitList,

    cardEnable: pData.cardEnable,
    alihkEnable: pData.alihkEnable,
    alicnEnable: pData.alicnEnable,
    wechatEnable: pData.wechatEnable,
    applePayEnable: pData.applePayEnable,
    googlePayEnable: pData.googlePayEnable,
    upiEnable: pData.upiEnable,

    wechatSubAppId: pData.wechatSubAppId,
    wechatSubMerchantId: pData.wechatSubMerchantId,
    tokenPoolMid: pData.tokenPoolMid,

    // Why are fees updated in this api...?
    gatewayFee: pData.gatewayFee,
    threeDSFee: pData.threeDSFee,
    tokenFee: pData.tokenFee,
  }
  return payload;
}

export const buildCreateOnlineMerchantMdrPayload = (data) => {
  const pData = applyPreprocessors(data, structuredClone(data), ["mdrList"]);
  const settleByUsd = pData.usdSettleCurrency === "USD";
  const payload = {
    merchantId: pData.merchantId, //from addMerchant api call

    bankAccount: pData.bankAccount || "",
    beneficiary: pData.beneficiary || "",
    email: pData.email,
    mdrList: pData.mdrList,
    merchantName: pData.name,
    sales: pData.sales ? { id: pData.sales } : null,
    referrer: pData.referrer ? { id: pData.referrer } : null,
    settleCycle: pData.settleCycle,
    zeroPlan: pData.zeroPlan,
    customSettle: pData.customSettle,
    merchantCurrencyList: settleByUsd ? [{
      currencyCode: "USD",
      settleCurrencyCode: pData.usdSettleCurrency,
    }] : null,
    merchantSettleCurrencyList: [{
      settleCurrencyCode: "USD",
      bankAccount: (settleByUsd && pData.usdBankAccount) || "",
      beneficiary: (settleByUsd && pData.usdBeneficiary) || "",
      // transFee: (settleByUsd && pData.usdTransFee) || 0, // deprecated field, trans_fee in merchant_settle_currency table will be 0 by default
      threeDSFee: (settleByUsd && pData.usdThreeDSFee) || 0,
      gatewayFee: (settleByUsd && pData.usdGatewayFee) || 0,
      tokenFee: (settleByUsd && pData.usdTokenFee) || 0,
    }]
  }
  return payload;
}

export const buildUpdateOnlineMerchantNuveiConfigPayload = (data) => {
  const pData = applyPreprocessors(data, structuredClone(data), []);

  const payload = {
    merchantId: pData.merchantId,
    siteId: pData.siteId,
    legalName: pData.legalName,
    phone: pData.phone,
    country: pData.countryOrRegion,
    city: pData.city,
  }
  return payload;
}

export const buildUpdateOnlineMerchantEntityPayload = (data) => {
  const staticPayload = {
    ...data,
    //append static values
    processor: "NUVEI",

    fpsEnable: false,
    amexEnable: false,
  }

  const pData = applyPreprocessors(staticPayload, structuredClone(staticPayload), ["base64EncodedTermsPdf", "base64EncodedImg", "preference", "tokenPoolMid", "currencyTxnLimitList"]);
  const castBoolean = (v) => Number(v);

  const payload = {
    merchantId: pData.merchantId,
    status: pData.status,

    displayName: pData.displayName,
    name: pData.name,
    countryOrRegion: pData.countryOrRegion,
    legalName: pData.legalName,
    businessRegistration: pData.businessRegistration,
    businessEstablishedDate: dayjs(pData.businessEstablishedDate).toISOString(),
    address: pData.address,
    addressSecondaryLang: pData.addressSecondaryLang,
    city: pData.city,
    stateOrProvince: pData.stateOrProvince,
    contactPerson: pData.contactPerson,
    email: pData.email,
    phone: pData.phone,
    mcc: pData.mcc,
    ...pData.base64EncodedImg && { base64EncodedImg: pData.base64EncodedImg },
    homepageUrl: pData.homepage_url,
    themeColor: pData.theme_color,
    countDown: pData.count_down,
    callbackCountdown: pData.callback_countdown,
    ...pData.base64EncodedTermsPdf && { base64EncodedTermsPdf: pData.base64EncodedTermsPdf },
    ...(pData.termsUrl != null) && { termsUrl: pData.termsUrl }, //handle empty string case
    isBoxsPayMerchant: castBoolean(pData.isBoxsPayMerchant),

    currencyList: pData.currencyList,
    shareholderInfo: pData.shareholderInfo,
    currencyTxnLimitList: pData.currencyTxnLimitList,

    cardEnable: castBoolean(pData.cardEnable),
    alihkEnable: castBoolean(pData.alihkEnable),
    alicnEnable: castBoolean(pData.alicnEnable),
    wechatEnable: castBoolean(pData.wechatEnable),
    applePayEnable: castBoolean(pData.applePayEnable),
    googlePayEnable: castBoolean(pData.googlePayEnable),
    upiEnable: castBoolean(pData.upiEnable),

    wechatSubAppId: pData.wechatSubAppId,
    wechatSubMerchantId: pData.wechatSubMerchantId,
    tokenPoolMid: pData.tokenPoolMid,

    // Why are fees updated in this api...?
    gatewayFee: pData.gatewayFee,
    threeDSFee: pData.threeDSFee,
    tokenFee: pData.tokenFee,
  }
  return payload;
}

export const buildUpdateOnlineMerchantSettleCurrencyPayload = (data) => {
  const pData = applyPreprocessors(data, structuredClone(data), []);
  const payload = {
    merchantId: pData.merchantId,
    currencyCode: "USD",
    settleCurrencyCode: pData.usdSettleCurrency,
  }
  return payload;
}

export const buildUpdateOnlineMerchantSettleCurrencyInfoPayload = (data) => {
  const pData = applyPreprocessors(data, structuredClone(data), []);
  const payload = {
    merchantId: pData.merchantId,

    settleCurrencyCode: "USD",
    bankAccount: pData.usdBankAccount || "",
    beneficiary: pData.usdBeneficiary || "",
    // transFee: pData.usdTransFee, // deprecated field, trans_fee in merchant_settle_currency table will be 0 by default
    threeDSFee: pData.usdThreeDSFee,
    gatewayFee: pData.usdGatewayFee,
    tokenFee: pData.usdTokenFee,
  }
  return payload;
}

/**
 * @param {*} data 
 * @param {keyof import("../Sections/OnlineMerchantManagementMdrSection").onlineProcessorCardConfig | "ALL"} cardType - Provide "ALL" to update all MDRs, null to skip
 * @returns 
 */
export const buildUpdateOnlineMerchantMdrPayload = (data, cardType) => {
  const pData = applyPreprocessors(data, structuredClone(data), ["mdrList"]);
  const mdrEntry = pData.mdrList.find((mdr) => mdr.cardType === cardType);
  const toBeUpdatedMdrList = cardType === "ALL" ? pData.mdrList : [mdrEntry].filter(Boolean);

  const payload = {
    merchantId: pData.merchantId,

    bankAccount: pData.bankAccount || "",
    beneficiary: pData.beneficiary || "",
    email: pData.email,
    mdrList: toBeUpdatedMdrList,
    merchantName: pData.name,
    sales: pData.sales ? { id: pData.sales } : null,
    referrer: pData.referrer ? { id: pData.referrer } : null,
    settleCycle: pData.settleCycle,
    zeroPlan: pData.zeroPlan,
    customSettle: pData.customSettle,
  }
  return payload;
}

export const buildUpdateOnlineMerchantStatusPayload = (data, suspensionRemarks) => {
  const pData = applyPreprocessors(data, structuredClone(data), []);

  const remarks = (() => {
    switch (true) {
      case pData.lockAccountType === "OTHERS":
        return pData.remark || "";
      case pData.status === "SUSPENDED":
        return suspensionRemarks.suspended?.[pData.lockAccountType] || "";
      case pData.status === "TERMINATED":
        return suspensionRemarks.terminated?.[pData.lockAccountType] || "";
      default:
        return "";
    }
  })();

  const payload = {
    id: pData.merchantId,
    merchantId: pData.merchantId,
    isStatusChange: true,
    status: pData.status,
    lockAccountType: pData.lockAccountType || "",
    remark: remarks
  }
  return payload;
}

export const buildUpdateOnlineEmployeePasswordApiPayload = (data) => {
  const pData = applyPreprocessors(data, structuredClone(data), []);
  const payload = {
    id: pData.id,
    password: sha256(pData.password).toString(),
  }
  return payload;
}

export const buildCreateOnlineEmployeeApiPayload = (data) => {
  const pData = applyPreprocessors(data, structuredClone(data), []);
  const payload = {
    merchantId: pData.merchantId,
    name: pData.name,
    email: pData.email,
    password: sha256(pData.password).toString(),
    ...!!pData.permission?.length && { permission: pData.permission },
  }
  return payload;
}

export const buildUpdateOnlineEmployeeDetailApiPayload = (data) => {
  const pData = applyPreprocessors(data, structuredClone(data), []);
  const payload = {
    id: pData.id,
    merchantId: pData.merchantId,
    name: pData.name,
    email: pData.email,
    permission: pData.permission?.length ? pData.permission : null,
    isBoxsPay: Number(pData.isBoxsPay),
  }
  return payload;
}

export const buildUpdateOnlineEmployeeStatusApiPayload = (data, suspensionRemarks) => {
  const pData = applyPreprocessors(data, structuredClone(data), []);

  const remarks = (() => {
    switch (true) {
      case pData.lockAccountType === "OTHERS":
        return pData.remark || "";
      case pData.status === "SUSPENDED":
        return suspensionRemarks.suspended?.[pData.lockAccountType] || "";
      case pData.status === "TERMINATED":
        return suspensionRemarks.terminated?.[pData.lockAccountType] || "";
      default:
        return "";
    }
  })();

  const payload = {
    id: pData.id,
    isStatusChange: true,
    status: pData.status,
    lockAccountType: pData.lockAccountType || "",
    remark: remarks
  }
  return payload;
}

/** 
 * @param {Object} orgData,
 * @param {Object} payload
 * @param {(keyof buildSpecialHandling)[]} processors
 */
const applyPreprocessors = (orgData, payload, processors) => {
  //note: orgData should NEVER be mutated
  const result = processors.reduce((acc, cur) => buildSpecialHandling[cur](orgData, acc), payload);
  return result
}


const buildSpecialHandling = {
  // orgData should not be mutated, and payload should be returned after mutation
  // Always use Orginal data to construct new payload

  "mdrList": (orgData, payload) => {
    // Pre-process the mdr list values from percentage integers to floats
    const handlePercentageNumString = (pn) => {
      // prevent floating point error
      if (typeof pn === "number") return Math.round(((pn || 0) / 100) * 1e10) / 1e10
      else return pn
    }

    const DEFAULT_MDR = {
      cost: 0, //deprecated field, kept for backwards compatibility
      mdr: 0,
      foreignMdr: 0,
      salesCommission: 0,
      referrerCommission: 0,
      remark: "",
    }

    payload.mdrList = structuredClone(orgData.mdrList);

    // Pre-process the mdr list values (from percentage integers to floats and add default values)
    Object.values(payload.mdrList).forEach((mdr) => {
      const parsedmdr = Object.fromEntries(Object.entries(mdr).map(([key, value]) => {
        if (key === "id") return [key, value]
        else return [key, handlePercentageNumString(value)]
      }))
      const tempMdr = { ...DEFAULT_MDR, ...parsedmdr };
      Object.assign(mdr, tempMdr);
    });

    // Transform the mdr list to an array for backend
    payload.mdrList = Object.entries(payload.mdrList).map(([cardType, mdr]) => {
      const isUnmodified = Object.values(mdr).every((v) => !v)
      if (isUnmodified) return
      return { cardType, ...mdr }
    }).filter(Boolean)

    return payload;
  },
  "base64EncodedImg": (orgData, payload) => {
    // remove the field completely if it is an url link (which means it is returned from the backend)
    // this field should only exist when the the merchant logo is being updated (base64 image)
    // an error will occur if a link is put into this field
    if (orgData.base64EncodedImg?.startsWith("https://")) delete payload.base64EncodedImg
    return payload;
  },
  "base64EncodedTermsPdf": (orgData, payload) => {
    // Put the base64 encoded terms pdf into base64EncodedTermsPdf, backend will upload it to S3 and the the S3 link will be put into field termsUrl
    // If it's a http link instead (edit merchant), put it into termsUrl instead
    delete payload.base64EncodedTermsPdf;
    switch (orgData.base64EncodedTermsPdf?.[0]?.type) {
      case "httpLink":
        payload.termsUrl = orgData.base64EncodedTermsPdf?.[0]?.content;
        break;
      case "pdf":
        payload.base64EncodedTermsPdf = orgData.base64EncodedTermsPdf?.[0]?.content;
        break;
      default:
        payload.termsUrl = ""; // empty case
    }
    return payload;
  },
  "preference": (orgData, payload) => {
    // Construct preference
    const GATEWAY_NONE = "NONE";

    const preference = JSON.stringify({
      gatewayMap: {
        VISA: orgData.cardEnable ? orgData.processor : GATEWAY_NONE,
        MASTER: orgData.cardEnable ? orgData.processor : GATEWAY_NONE,
        UNIONPAY: orgData.upiEnable ? "FUBON" : GATEWAY_NONE,
        ALIPAY: (orgData.alihkEnable || orgData.alicnEnable) ? "ALIPAY" : GATEWAY_NONE,
        WECHAT: orgData.wechatEnable ? "WECHAT_PAY" : GATEWAY_NONE,

        // Processors below are not used, only presrved for backwards compatibility
        AMEX: orgData.amexEnable ? "AMEX_BBMSL" : GATEWAY_NONE,
        DINERS: orgData.cardEnable ? orgData.processor : GATEWAY_NONE,
        JCB: orgData.cardEnable ? orgData.processor : GATEWAY_NONE,
        VERVE: orgData.cardEnable ? orgData.processor : GATEWAY_NONE,
        DISCOVER: orgData.cardEnable ? orgData.processor : GATEWAY_NONE,
        LOYALTY: orgData.cardEnable ? orgData.processor : GATEWAY_NONE,
      },
      businessRules: null,
      partialAuthIndicator: null,
      networkOrder: null
    })

    payload.preference = preference
    return payload;
  },
  "tokenPoolMid": (orgData, payload) => {
    // remove the field completely if it is empty (operation portal logic)
    if (!orgData.tokenPoolMid) delete payload.tokenPoolMid
    return payload;
  },
  "currencyTxnLimitList": (orgData, payload) => {
    const currencyTxnLimitList = JSON.stringify(Object.fromEntries(
      orgData.currencyTxnLimitList.map(({ currency, amountLimit }) => ([currency, amountLimit]))
    ))

    payload.currencyTxnLimitList = currencyTxnLimitList
    return payload;
  },
}